import validate from 'validate.js'

const constraints = {
  payslipId: {
    presence: true
  }
}

export default (data) => {
  return validate(data, constraints)
}
